import { Expose, Type } from 'class-transformer';
import { Model } from '@shared/models/model';
import { AvlDevice } from '../../live-tracking/models/avl-device.model';
import { AvlDevicePosition } from '../../live-tracking/models/avl-device-position,model';

export class ShipmentRoadFromTraccar extends Model {
    @Type(()=> AvlDevicePosition)
    @Expose()
    deviceHistory: AvlDevicePosition[]=[];

    @Type(()=> AvlDevice)
    @Expose()
    deviceStatus: AvlDevice = new AvlDevice();

}
